import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-16 h-16 border-4 border-slate-200 border-t-slate-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    const loginPath = requiredRole === 'superadmin' ? '/superadmin/login' : '/admin/login';
    return <Navigate to={loginPath} replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    const loginPath = requiredRole === 'superadmin' ? '/superadmin/login' : '/admin/login';
    return <Navigate to={loginPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
